// extracted by mini-css-extract-plugin
export default {"sort":"AS-z","sortSelect":"BS-z","disabled":"CS-z"};